/** Readable access rows; entering edit mode does not change permissions. Existing PATCH handlers remain authoritative. */
export function bindShareRowEditors(dialog: HTMLDialogElement): void {
  dialog.querySelectorAll<HTMLElement>(".member-row").forEach(row => {
    const role = row.querySelector<HTMLSelectElement>("select[data-member-role], select[data-task-share-role], select[data-collection-share-role]");
    if (!role || row.querySelector("[data-access-edit]")) return;
    const email = row.querySelector("strong")?.textContent || "collaborator";
    const identity = role.getAttributeNames().find(name => name.startsWith("data-"))!;
    const key = `${identity}:${role.getAttribute(identity)}`;
    const open = dialog.dataset.accessEditing === key;
    row.classList.add("access-row");
    const description = row.querySelector<HTMLElement>(":scope > div");
    const roleText = dialog.ownerDocument.createElement("small");
    roleText.className = "access-row__role";
    roleText.textContent = role.selectedOptions[0]?.textContent || role.value;
    // Space rows already show their role; grant rows show expiry separately.
    if (identity === "data-member-role") description?.querySelector("small")?.remove();
    description?.append(roleText);
    const edit = dialog.ownerDocument.createElement("button");
    edit.type = "button"; edit.className = "text-button access-row__edit"; edit.dataset.accessEdit = "";
    edit.textContent = "Edit"; edit.setAttribute("aria-label", `Edit access for ${email}`); edit.setAttribute("aria-expanded", String(open));
    const fields = dialog.ownerDocument.createElement("div");
    fields.className = "access-row__fields"; fields.hidden = !open;
    const controls = [...row.querySelectorAll<HTMLInputElement | HTMLSelectElement | HTMLButtonElement>(":scope > select, :scope > input, :scope > button")];
    controls.forEach(control => {
      if (control.tagName === "BUTTON") { fields.append(control); return; }
      const label = dialog.ownerDocument.createElement("label"); label.className = "field-label";
      label.append(control === role ? "Role" : "Expires", control); fields.append(label);
    });
    const note = dialog.ownerDocument.createElement("small"); note.className = "access-row__note"; note.textContent = "Changes save immediately. Done only closes these controls.";
    const done = dialog.ownerDocument.createElement("button"); done.type = "button"; done.className = "text-button"; done.textContent = "Done";
    fields.append(note, done); row.append(edit, fields);
    edit.addEventListener("click", () => {
      fields.hidden = false; edit.setAttribute("aria-expanded", "true"); dialog.dataset.accessEditing = key; role.focus();
    });
    done.addEventListener("click", () => {
      if (dialog.hasAttribute("aria-busy") || fields.querySelector('[aria-invalid="true"]')) return;
      fields.hidden = true; edit.setAttribute("aria-expanded", "false"); delete dialog.dataset.accessEditing; edit.focus();
    });
    if (open) requestAnimationFrame(() => { if (!dialog.hasAttribute("aria-busy")) row.querySelector<HTMLElement>("[data-access-edit]")?.focus({ preventScroll: true }); });
  });
}
